import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "/public/css/goods.css";
import { computed, ref, onMounted } from 'vue';
import { useRouter } from "vue-router";
import { useStore } from 'vuex';
import httpRequest from '@/request/index';
import { showFailToast } from 'vant';
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    let page = ref(1),
      cid = ref(0),
      pageSize = ref(10);
    let loading = ref(false),
      finished = ref(false);
    let list = ref([]);
    let clist = ref([]);
    let active = ref(0);
    let keywords = ref("");
    const isShow = ref(false);
    const ClassSel = id => {
      cid.value = id;
      list.value = [];
      page.value = 1;
      loading.value = false;
      finished.value = false;
      console.log("重新获取");
      loadData();
      loading.value = true;
    };
    const goSearch = val => {
      console.log(val);
      router.push({
        path: "/goods/search",
        query: {
          keywords: val
        }
      });
    };
    const loadData = () => {
      console.log("获取数据");
      httpRequest({
        method: "get",
        url: "?file=goods",
        params: {
          cid: cid.value,
          page: page.value
        }
      }).then(res => {
        if (res.state == 1) {
          loading.value = false;
          const _list = res.list;
          list.value = [...list.value, ..._list];
          if (_list.length < pageSize.value) {
            finished.value = true;
          }
          page.value++;
        } else {
          showFailToast(res.msg);
        }
      });
    };
    const addCart = (id, no) => {
      store.dispatch("addCart", {
        id: id,
        count: no
      });
    };
    const editCart = (value, detail) => {
      store.dispatch("editCart", {
        id: detail.name,
        count: value
      });
    };
    const delCart = (id, no) => {
      if (cartList.value[id].count < no) {
        store.dispatch("editCart", {
          id: id,
          count: 0
        });
      }
    };
    let cartList = computed(() => {
      return store.state.cartItem;
    });
    onMounted(async () => {
      await store.dispatch("cklogin").then(() => {
        if (!store.state.isLogin) {
          router.replace("/login");
        }
      });
      await httpRequest({
        method: "get",
        url: "?file=goods&act=class"
      }).then(res => {
        if (res.state == 1) {
          clist.value = res.list;
          pageSize.value = res.limit;
          ClassSel(clist.value[0].id);
        } else {
          showFailToast(res.msg);
        }
      });
      console.log("可以开始了");
      let id = router.currentRoute.value.query.cid;
      if (id > 0) {
        clist.value.forEach((el, key) => {
          if (el.id == id) {
            cid.value = id;
            active.value = key;
            ClassSel(id);
          }
        });
      }
      isShow.value = true;
    });
    //console.log("cartList",cartList)
    return {
      loading,
      finished,
      active,
      ClassSel,
      list,
      cartList,
      loadData,
      addCart,
      editCart,
      delCart,
      clist,
      keywords,
      goSearch,
      isShow
    };
  }
};